module.exports = __webpack_public_path__ + "img/icon_closeR.70672c8e.svg";